"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '-6.1 -12 16 16'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: 'currentColor',
    transform: 'rotate(-90)',
    d: "M3.99107215,5.01071718 C3.77048509,5.01098961 3.56046674,4.91624449 3.41468752,4.75069345 L0.144063123,1.03302927 C-0.0709324363,0.776809483 -0.0420631074,0.395814826 0.209085403,0.174916443 C0.460233914,-0.0459819407 0.841797098,-0.0259843627 1.06847872,0.219956912 L3.92839991,3.47091289 C3.94422437,3.48896608 3.96706525,3.4993185 3.99107215,3.4993185 C4.01507905,3.4993185 4.03791993,3.48896608 4.05374439,3.47091289 L6.91366558,0.219956912 C7.05725972,0.0488293769 7.28227805,-0.0310987892 7.50164774,0.0111013243 C7.72101743,0.0533014377 7.90032179,0.211009098 7.97017742,0.423197933 C8.04003305,0.635386768 7.98948037,0.868766688 7.83808118,1.03302927 L4.56845687,4.74936 C4.42242804,4.91531178 4.21212501,5.01050669 3.99107215,5.01071718 Z"
  }));
});